import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class RoutesRequest extends CrudRequest {
  static baseUrl() {
    return 'backofficeapi/route';
  }

  static edit(id, payload) {
    return httpService.patch(
      `${this.baseUrl()}/${id}`,
      payload,
    );
  }
}
